import '../css/Footer.css';
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Stack} from '@chakra-ui/react';


function Footer  ()  {
    return (
        
        

        <div className="Footer">
        <br></br><br></br><br></br>
        <hr className='container'></hr>
        <br></br>         
        <div className="footer_area ">
          <div className="container-lg">
            <div className='row'>
              
              <div className="col-12 col-sm-6 col-lg-4">
                <div className="single-footer-widget section_padding_0_130">
                 
                  <div className="footer-logo mb-3"></div>
                  <h6 className="widget-title text-primary">Altius Investech</h6>
                  <h6 className="widget-title ">Social</h6>
                  <Stack direction='row'>
                   <a href="#"><img className="img"
                    src="/facebooklogo.jpg" alt=""/></a>
                  
                  <a href="#"><img className="img"       
                    src="/twitterlogo.png" alt="" /></a>
                    
                    <a href="#"><img className="img"       
                      src="/linkedinlogo.png" alt="" /></a> 
                   
                    <a href="#"><img className="img"       
                      src="/instalogo.png" alt="" /></a>
                    </Stack>
                   <br></br><br></br>
                    <h6 className="widget-title ">Registered Office</h6>
                  <p className="text-muted">2nd Floor, Room 201, 73A, Ganesh Chandra Ave, Chandni Chawk, Bowbazar, Kolkata, West Bengal 700013</p>
                  
                  <div className="footer_social_area"></div>
                </div>
              </div>
              
              <div className="col-12 col-sm-6 col-lg">
                <div className="single-footer-widget section_padding_0_130">
                  
                  
                  <h6 className="widget-title text-primary">Company</h6>
                  
                  <div className="footer_menu">
                    <ul>
                      <li><a href="#">Home</a></li>
                      <li><a href="#">About us</a></li>
                      <li><a href="#">How it works</a></li>
                      <li><a href="#">Press</a></li>
                    </ul>   
                  </div>
                </div>
              </div>
              
              <div className="col-12 col-sm-6 col-lg">
                <div className="single-footer-widget section_padding_0_130">
                  
                 
                  <div className="footer_menu">
                    <br></br>
                    <ul>
                      <li><a href="#">Blog</a></li>
                      <li><a href="#">Contact us</a></li>
                    </ul>
                  </div>
                </div>
              </div>
              
              <div className="col-12 col-sm-6 col-lg">
                <div className="single-footer-widget section_padding_0_130">
                  
                  
                  
                  <h6 className="widget-title text-primary">Guick Links</h6>
                  
                  <div className="footer_menu">
                    <ul>
                      <li><a href="#">A Complete Walkthrough Of Our Trading Portal</a></li>
                      <li><a href="#">Capital Gain on Sale of Unlisted Shares</a></li>
                      <li><a href="#">How to transfer unlisted shares?</a></li>
                      <li><a href="#">Income Tax on Unlisted Shares</a></li>
                    </ul>
                  </div>
                </div>
              </div>
             <br></br><br></br>  
          <div className="footer-copyright text-center py-3 text-muted">All rights reserved. Copyright © 2022 Altius Investech
          </div>
        
            </div>
            </div>

</div>
</div>
    );
}

export default Footer;